import React from 'react';
import './EqxDisplayUom.css';

export interface EqxDisplayUomProps {
    value: number;
    uom: string;
    currencySymbol?: string;
    className?: string;
}

export interface EqxDisplayUomInputProps {
    uom: string;
    className?: string;
    currencySymbol?: string;
    children: React.ReactNode;
}

const EqxDisplayUom: React.FC<EqxDisplayUomProps> = ({ value, uom, currencySymbol, className = '' }) => {
    if (currencySymbol) {
        return (
            <span className={`eqx-display-uom currency ${className}`}>
                {currencySymbol}{value.toFixed(2)}
            </span>
        );
    }

    return (
        <span className={`eqx-display-uom ${className}`}>
            {value} {uom}
        </span>
    );
};

const EqxDisplayUomInput: React.FC<EqxDisplayUomInputProps> = ({
    uom,
    currencySymbol,
    className = '',
    children
}) => {
    // If UOM is null, undefined, or blank, just return the children without wrapping
    if (!uom || uom.trim() === '') {
        return <>{children}</>;
    }

    if (currencySymbol) {
        return (
            <div className={`input-group ${className}`}>
                <span className="input-group-text">{currencySymbol}</span>
                {children}
            </div>
        );
    }

    return (
        <div className={`input-group ${className}`}>
            {children}
            <span className="input-group-text">{uom}</span>
        </div>
    );
};

export { EqxDisplayUomInput };
export default EqxDisplayUom; 